import { jsxs, jsx } from "react/jsx-runtime";
const IconBluetoothSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M12 22a.999.999 0 0 1-1-1v-6.586l-2.793 2.793a1 1 0 1 1-1.414-1.414L10.586 12 6.793 8.207a1 1 0 1 1 1.414-1.414L11 9.586V3a.999.999 0 0 1 1.707-.707l4.5 4.5a1 1 0 0 1 0 1.414L13.414 12l3.793 3.793a1 1 0 0 1 0 1.414l-4.5 4.5A1 1 0 0 1 12 22Zm1-7.586v4.172l2.086-2.086L13 14.414Zm0-9v4.172L15.086 7.5 13 5.414Z" })
    ]
  }
);
export {
  IconBluetoothSvg
};
